import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="bg-neutral-dark text-white mt-auto">
      <div className="container-responsive py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <span className="text-metro-blue font-bold text-xl">M</span>
              </div>
              <span className="font-bold text-xl">Indian Metro</span>
            </div>
            <p className="text-gray-400 text-sm">
              Metro rail information for 23 Indian cities. Route planning, fare calculator, and more.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/route" className="text-gray-400 hover:text-white transition-colors">
                  Route Planner
                </Link>
              </li>
              <li>
                <Link to="/fare" className="text-gray-400 hover:text-white transition-colors">
                  Fare Calculator
                </Link>
              </li>
              <li>
                <Link to="/map" className="text-gray-400 hover:text-white transition-colors">
                  Metro Map
                </Link>
              </li>
              <li>
                <Link to="/stations" className="text-gray-400 hover:text-white transition-colors">
                  All Stations
                </Link>
              </li>
            </ul>
          </div>

          {/* Nearby */}
          <div>
            <h3 className="font-semibold mb-4">Nearby</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/nearby/tourist" className="text-gray-400 hover:text-white transition-colors">
                  Tourist Places
                </Link>
              </li>
              <li>
                <Link to="/nearby/hotels" className="text-gray-400 hover:text-white transition-colors">
                  Hotels
                </Link>
              </li>
              <li>
                <Link to="/nearby/bus" className="text-gray-400 hover:text-white transition-colors">
                  Bus Stops
                </Link>
              </li>
              <li>
                <Link to="/smart-card" className="text-gray-400 hover:text-white transition-colors">
                  Smart Card
                </Link>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="font-semibold mb-4">Information</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/cities" className="text-gray-400 hover:text-white transition-colors">
                  All Cities
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>Data sourced from official metro authority websites.</p>
          <p className="mt-2">© {new Date().getFullYear()} Indian Metro Web. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
